module.exports = __webpack_public_path__ + "static/media/DownloadCSV.046a7f18.svg";